import { render, staticRenderFns } from "./k-common-menu.vue?vue&type=template&id=68445f70&scoped=true&"
import script from "./k-common-menu.vue?vue&type=script&lang=js&"
export * from "./k-common-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68445f70",
  null
  
)

export default component.exports